import classNames from 'classnames';

import ErrorBlock from '../../../../../common/ErrorBlock';
import { useActiveVoucherCount } from '../../../../../hooks/queries/useActiveVoucherCount';
import { TicketIcon } from '../../../../../icons/TicketIcon';
import { formatError } from '../../../../../util/errors';

export interface VoucherMessageProps {
  className?: string;
  body?: React.ReactNode;
  /** Use when the cached query count is stale (e.g. right after booking with a voucher). */
  availableVoucherCount?: number;
}

export const VoucherMessage = ({ className, body, availableVoucherCount }: VoucherMessageProps) => {
  const {
    voucherCount,
    vouchers,
    isLoading: isVoucherLoading,
    error: vouchersError,
  } = useActiveVoucherCount(availableVoucherCount);

  if (voucherCount === 0 || isVoucherLoading) {
    return null;
  }

  return (
    <div
      className={classNames(
        'mb-0 rounded-lg border border-slate-2 bg-white px-6 py-5 shadow md:-mb-5 lg:p-10 lg:py-8',
        className
      )}
    >
      {vouchersError && <ErrorBlock errorMsg={formatError(vouchersError)} />}
      {(vouchers || voucherCount > 0) && (
        <div className="flex flex-row gap-3">
          <div className="flex !w-6 items-start justify-center">
            <TicketIcon width={24} height={24} className="mt-[2px] fill-blood-orange-4" />
          </div>
          <div className="flex flex-col items-start gap-y-3">
            <p className="text-base font-bold">
              You have {voucherCount} voucher{voucherCount > 1 ? 's' : ''} available to use
            </p>
            <>{body}</>
          </div>
        </div>
      )}
    </div>
  );
};
